var portfolioList = {
	label: {
		caption: "Lista de la Cartera",
		name: "Cartera",
		currency: "Divisa",
		numberOfPositions: "Posiciones",
		numberOfTransactions: "Transacciones",
		actions: "Acciones"
	},
	noPortfolios: {
		title: "Info",
		message: "Aún no se ha creado ninguna cartera. Haga clic en el botón \"Añadir cartera\" y complete el formulario para crear una cartera."
	},
	error: {
		title: "Se ha producido un error.",
		portfolioLimitExceeded: "Se ha superado el límite de la cartera."
	},
	createPortfolioAction: "Añadir Cartera",
	editPortfolioAction: "Editar Cartera",
	deletePortfolioAction: "Eliminar Cartera",
	showActions: "Mostrar acciones"
};
var es = {
	portfolioList: portfolioList
};

export { es as default, portfolioList };
